import { render, staticRenderFns } from "./AgendaCalendarSkeleton.vue?vue&type=template&id=5c21ef07&scoped=true"
import script from "./AgendaCalendarSkeleton.vue?vue&type=script&lang=js"
export * from "./AgendaCalendarSkeleton.vue?vue&type=script&lang=js"
import style0 from "./agenda-calendar.scss?vue&type=style&index=0&id=5c21ef07&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21ef07",
  null
  
)

export default component.exports